(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  function applyColorVariantCard(item) {
    const variantImageUrl = item.dataset.variantImageUrl;
    const variantUrl = item.dataset.variantUrl;

    // Try the slide-aware swap first (snippets/card-variant-slide-swap);
    // only fall back to img-hijack if the card has no slideshow slides.
    const swapped = window.voksiSwapToVariantSlide?.(item);
    if (!swapped && variantImageUrl) {
      const img = item.querySelector('.card-gallery img');
      if (img && img.src !== variantImageUrl) {
        img.srcset = variantImageUrl;
        img.src = variantImageUrl;
      }
    }

    if (variantUrl) {
      item.querySelectorAll('a[href*="/products/"]').forEach((link) => {
        if (link.href !== variantUrl) {
          link.href = variantUrl;
        }
      });
    }

    const colorName = item.dataset.variantColorName;
    if (colorName && item.dataset.colorNameOverridden !== 'true') {
      const colorNameEl = item.querySelector('.color-name__text');
      if (colorNameEl && colorNameEl.textContent !== colorName) {
        colorNameEl.textContent = colorName;
      }
    }

    // Override the price block output with the color variant's actual price.
    // The server-rendered price block uses product.selected_or_first_available_variant,
    // which ignores our disabled/market metafields and can show wrong prices.
    const variantPriceHtml = item.dataset.variantPriceHtml;
    if (variantPriceHtml) {
      const priceContainer = item.querySelector('product-price [ref="priceContainer"]');
      if (priceContainer && priceContainer.innerHTML !== variantPriceHtml) {
        priceContainer.innerHTML = variantPriceHtml;
      }
      const volumeNote = item.querySelector('product-price .volume-pricing-note');
      if (volumeNote) volumeNote.remove();
    }

    window.voksiApplyVariantBadge?.(item);
  }

  function applyAllColorVariantCards(root) {
    root.querySelectorAll('.product-grid__item--color-variant').forEach(applyColorVariantCard);
  }

  // --- Price filter fix for color-split cards ---
  // Shopify's price filter uses product.price (cheapest variant), but color-split
  // cards display individual variant prices. We rename the min price input so
  // Shopify doesn't filter by min price server-side, and handle it client-side.

  const VARIANT_PRICE_MIN_PARAM = 'variant_price_gte';

  function getCollectionCacheKey() {
    return 'priceMax:' + window.location.pathname;
  }

  function getCachedPriceMax() {
    try { return parseInt(sessionStorage.getItem(getCollectionCacheKey()) || '0', 10); }
    catch { return 0; }
  }

  function setCachedPriceMax(value) {
    try { sessionStorage.setItem(getCollectionCacheKey(), value.toString()); }
    catch {}
  }

  function formatMoneyCents(cents, priceFacet, statusEl) {
    const moneyTemplate = priceFacet.closest('details')?.querySelector('template[ref="moneyFormat"]');
    const fallbackFormat = '{' + '{amount}' + '}';
    const format = moneyTemplate?.content?.textContent || fallbackFormat;
    const currency = statusEl?.dataset.currency || '';
    const val = cents / 100;
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/g;

    return format.replace(placeholderRegex, (_, p) => {
      if (p === 'currency') return currency;
      let sep = ',', dec = '.', prec = 2;
      if (p === 'amount_no_decimals') prec = 0;
      else if (p === 'amount_with_comma_separator') { sep = '.'; dec = ','; }
      else if (p === 'amount_no_decimals_with_comma_separator') { sep = '.'; prec = 0; }
      else if (p === 'amount_no_decimals_with_space_separator') { sep = ' '; prec = 0; }
      else if (p === 'amount_with_space_separator') { sep = ' '; dec = ','; }
      else if (p === 'amount_with_period_and_space_separator') { sep = ' '; }
      else if (p === 'amount_with_apostrophe_separator') { sep = "'"; }
      let [whole, frac] = val.toFixed(prec).split('.');
      whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      return frac ? whole + dec + frac : whole;
    });
  }

  // Rename min price inputs so Shopify doesn't filter by min price server-side.
  // After morph, server HTML has the original name — we must rename again.
  function patchPriceMinInputs() {
    document.querySelectorAll('input[name="filter.v.price.gte"]').forEach((input) => {
      input.name = VARIANT_PRICE_MIN_PARAM;
    });
  }

  // After morph, the min input is empty (Shopify doesn't know about our param).
  // Restore the value from the URL if present.
  function restorePriceMinValue() {
    const params = new URLSearchParams(window.location.search);
    const minValue = params.get(VARIANT_PRICE_MIN_PARAM);
    if (minValue) {
      document.querySelectorAll('input[name="' + VARIANT_PRICE_MIN_PARAM + '"]').forEach((input) => {
        if (!input.value) input.value = minValue;
      });
    }
  }

  function applyPriceFilterFixes(root) {
    const cards = root.querySelectorAll('.product-grid__item--color-variant[data-variant-price]');

    // Rename min inputs first (they may have been re-rendered by morph)
    patchPriceMinInputs();
    restorePriceMinValue();

    // Compute max price from currently visible cards
    let cardsMaxPrice = 0;
    cards.forEach((card) => {
      const price = parseInt(card.dataset.variantPrice, 10);
      if (price > cardsMaxPrice) cardsMaxPrice = price;
    });

    // Use the highest of: cached max, current cards max
    const cachedMax = getCachedPriceMax();
    const actualMaxPrice = Math.max(cardsMaxPrice, cachedMax);
    if (actualMaxPrice > cachedMax) setCachedPriceMax(actualMaxPrice);

    // Update all price filter components
    document.querySelectorAll('price-facet-component').forEach((priceFacet) => {
      const minInput = priceFacet.querySelector('[ref="minInput"]');
      const maxInput = priceFacet.querySelector('[ref="maxInput"]');
      const statusEl = priceFacet.closest('details')?.querySelector('[ref="facetStatus"]');
      const highestPriceEl = priceFacet.querySelector('.price-facet__highest-price');
      if (!maxInput) return;

      const shopifyRangeMax = parseInt(statusEl?.dataset.rangeMax || '0', 10);
      const displayMax = Math.max(shopifyRangeMax, actualMaxPrice);

      if (displayMax > shopifyRangeMax) {
        const displayMaxFormatted = (displayMax / 100).toString();

        // Update input constraints
        maxInput.setAttribute('data-max', displayMaxFormatted);
        if (!maxInput.value) maxInput.placeholder = displayMaxFormatted;
        if (minInput) minInput.setAttribute('data-max', maxInput.value || displayMaxFormatted);

        // Update facet status range
        if (statusEl) statusEl.dataset.rangeMax = displayMax.toString();

        // Update "highest price is X" text
        const priceSpan = highestPriceEl?.querySelector('[data-price-amount]');
        if (priceSpan) {
          priceSpan.innerHTML = formatMoneyCents(displayMax, priceFacet, statusEl);
          priceSpan.dataset.priceAmount = displayMax.toString();
        }
      }
    });

    // Hide color-variant cards whose variant price falls outside the active price filter
    const params = new URLSearchParams(window.location.search);
    const filterGte = params.get(VARIANT_PRICE_MIN_PARAM);
    const filterLte = params.get('filter.v.price.lte');
    if (filterGte || filterLte) {
      const filterMin = filterGte ? parseFloat(filterGte) * 100 : 0;
      const filterMax = filterLte ? parseFloat(filterLte) * 100 : Infinity;
      cards.forEach((card) => {
        const price = parseInt(card.dataset.variantPrice, 10);
        card.style.display = (price < filterMin || price > filterMax) ? 'none' : '';
      });
    }
  }

  // --- Multi-color taxonomy filter resolution ---
  // Taxonomy color filters use GIDs that can't be matched to option names in Liquid.
  // For multi-color filters, Liquid renders all colors with .color-unresolved class,
  // then JS probes the Section Rendering API with each GID individually to discover
  // which productId:colorName pairs match, and reveals only those cards.

  // Inject hiding rule via JS so no-JS users see all cards (graceful degradation)
  (function() {
    const s = document.createElement('style');
    s.textContent = '.color-unresolved{display:none}';
    document.head.appendChild(s);
  })();

  let resolveController = null;
  async function resolveMultiColorFilter(resultsList) {
    // Abort any in-flight resolution (e.g., user clicked another filter while probing)
    if (resolveController) resolveController.abort();

    const filterParam = resultsList.dataset.colorFilterParam;
    const gidsStr = resultsList.dataset.colorFilterGids;
    if (!filterParam || !gidsStr) return;

    const gids = gidsStr.split(',');
    if (gids.length < 2) return;

    resolveController = new AbortController();
    const signal = resolveController.signal;

    // Skip if no unresolved cards (e.g., after resolution already ran or no multi-filter)
    const unresolvedCards = resultsList.querySelectorAll('.color-unresolved');
    if (unresolvedCards.length === 0) return;

    // Collect all card color names per product for matching against probe results
    const cardColorsByProduct = new Map();
    unresolvedCards.forEach((card) => {
      const pid = card.dataset.productId;
      if (!cardColorsByProduct.has(pid)) cardColorsByProduct.set(pid, new Set());
      cardColorsByProduct.get(pid).add(card.dataset.variantColorName);
    });

    const allowedKeys = new Set();
    let truncated = false;

    try {
      // Probe the lightweight color-filter-probe section (paginates by 250)
      // with each GID individually. Strip page param to always get full results.
      const fetches = gids.map(async (gid) => {
        const probeUrl = new URL(window.location.pathname, window.location.origin);
        const currentParams = new URLSearchParams(window.location.search);
        for (const [key, value] of currentParams.entries()) {
          if (key === filterParam || key === 'page') continue;
          probeUrl.searchParams.append(key, value);
        }
        probeUrl.searchParams.set(filterParam, gid);
        probeUrl.searchParams.set('section_id', 'color-filter-probe');
        probeUrl.searchParams.sort();

        const response = await fetch(probeUrl.toString(), { signal });
        if (!response.ok) throw new Error('Probe failed');
        const text = await response.text();
        // Extract JSON from between delimiters (Shopify wraps section in a <div>)
        const jsonMatch = text.match(/<!--PROBE_JSON-->([\s\S]*?)<!--\/PROBE_JSON-->/);
        if (!jsonMatch) return;
        const data = JSON.parse(jsonMatch[1]);

        if (data.pages > 1) truncated = true;

        // For each product, match its selected_variant options against card color names
        data.items.forEach((item) => {
          const cardColors = cardColorsByProduct.get(String(item.p));
          if (!cardColors) return;
          item.v.forEach((optionValue) => {
            if (cardColors.has(optionValue)) {
              allowedKeys.add(item.p + ':' + optionValue);
            }
          });
        });
      });

      const results = await Promise.allSettled(fetches);
      if (signal.aborted) return;

      const anyFailed = results.some((r) => r.status === 'rejected');

      // If probes failed or collection exceeds 250 products, reveal all (graceful degradation)
      resultsList.querySelectorAll('.color-unresolved').forEach((card) => {
        const key = card.dataset.productId + ':' + card.dataset.variantColorName;
        if (anyFailed || truncated || allowedKeys.has(key)) {
          card.classList.remove('color-unresolved');
        }
      });
    } catch (e) {
      if (signal.aborted) return;
      // On unexpected error, reveal all cards (graceful degradation)
      resultsList.querySelectorAll('.color-unresolved').forEach((card) => {
        card.classList.remove('color-unresolved');
      });
    } finally {
      if (!signal.aborted) resolveController = null;
    }
  }

  // --- Client-side price sort for the collection grid ---
  // Shopify's price sort uses product.price_min, which includes variants disabled
  // via our custom metafields. It also can't reorder color-split cards within a
  // product (they render in color option order, not price order). We use CSS
  // `order` to fix the visual order without touching DOM order — keeping
  // pagination/refs/infinite-scroll working.
  function sortCardsByPrice(root) {
    const params = new URLSearchParams(window.location.search);
    const sortBy = params.get('sort_by');
    const isPriceAsc = sortBy === 'price-ascending';
    const isPriceDesc = sortBy === 'price-descending';
    const sortActive = isPriceAsc || isPriceDesc;

    const searchRoot = root && root.querySelectorAll ? root : document;
    const grids = searchRoot.querySelectorAll('ul.product-grid');
    if (!grids.length) return;

    grids.forEach((grid) => {
      grid.querySelectorAll(':scope > .product-grid__item').forEach((card) => {
        if (!sortActive) {
          if (card.style.order) card.style.removeProperty('order');
          return;
        }
        const price = parseInt(card.dataset.variantPrice || '0', 10);
        const order = isPriceAsc ? price : -price;
        const orderStr = String(order);
        if (card.style.order !== orderStr) {
          card.style.order = orderStr;
        }
      });
    });
  }

  function applyAllFixes(root) {
    applyAllColorVariantCards(root);
    applyPriceFilterFixes(root);
    sortCardsByPrice(root);

    const resultsList = root.closest
      ? root.closest('results-list') || root.querySelector('results-list')
      : root.querySelector('results-list');
    if (resultsList) resolveMultiColorFilter(resultsList);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => applyAllFixes(document), { once: true });
  } else {
    applyAllFixes(document);
  }

  // Clean up empty variant_price_gte from URL after form clears the min input
  const _pushState = history.pushState.bind(history);
  history.pushState = function(state, title, url) {
    if (url && typeof url === 'string' || url instanceof URL) {
      const u = new URL(url, window.location.origin);
      if (u.searchParams.get(VARIANT_PRICE_MIN_PARAM) === '') {
        u.searchParams.delete(VARIANT_PRICE_MIN_PARAM);
        url = u.toString();
      }
    }
    return _pushState(state, title, url);
  };

  const grid = document.querySelector('results-list');
  if (grid) {
    let isApplying = false;
    new MutationObserver(() => {
      if (isApplying) return;
      isApplying = true;
      applyAllFixes(grid);
      isApplying = false;
    }).observe(grid, { childList: true, subtree: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  // Swap helper lives in snippets/card-variant-slide-swap.liquid; we call it
  // here via the global so this and main-collection share a single source.
  function applyMarketVariantFix(item) {
    var variantImageUrl = item.dataset.variantImageUrl;
    var variantUrl = item.dataset.variantUrl;
    var swapped = window.voksiSwapToVariantSlide && window.voksiSwapToVariantSlide(item);
    if (!swapped && variantImageUrl) {
      var img = item.querySelector('.card-gallery img');
      if (img && img.src !== variantImageUrl) {
        img.srcset = variantImageUrl;
        img.src = variantImageUrl;
      }
    }
    if (variantUrl) {
      item.querySelectorAll('a[href*="/products/"]').forEach(function(link) {
        if (link.href !== variantUrl) {
          link.href = variantUrl;
        }
      });
    }
    var variantPriceHtml = item.dataset.variantPriceHtml;
    if (variantPriceHtml) {
      var priceContainer = item.querySelector('product-price [ref="priceContainer"]');
      if (priceContainer && priceContainer.innerHTML !== variantPriceHtml) {
        priceContainer.innerHTML = variantPriceHtml;
      }
      var volumeNote = item.querySelector('product-price .volume-pricing-note');
      if (volumeNote) volumeNote.remove();
    }

    if (window.voksiApplyVariantBadge) window.voksiApplyVariantBadge(item);
  }

  var grid = document.querySelector('results-list');
  if (grid) {
    var isApplying = false;
    // applyMarketVariantFix moves <img> nodes between slides, which is itself
    // a childList mutation that would re-fire this observer. The guard plus
    // the swap helper's idempotency together prevent runaway re-entry.
    new MutationObserver(function() {
      if (isApplying) return;
      isApplying = true;
      grid.querySelectorAll('[data-variant-image-url], [data-variant-price-html]').forEach(applyMarketVariantFix);
      isApplying = false;
    }).observe(grid, { childList: true, subtree: true });
  }

  } catch(e) { console.error(e); }
})();
})();
